/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Hotel service api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { AddHotelBlockRequest } from '../model';
// @ts-ignore
import { GetHotelBlockDetailsResponse } from '../model';
// @ts-ignore
import { GetHotelBlockListResponse } from '../model';
// @ts-ignore
import { GetVisibleHotelBlockResponse } from '../model';
// @ts-ignore
import { HotelBlockResponse } from '../model';
// @ts-ignore
import { UpdateHotelBlockRequest } from '../model';
/**
 * HotelBlocksApiApiHotelAddHotelBlockPost - axios parameter creator
 * 
 * @summary Add Hotel Block with details
 * @param {AddHotelBlockRequest} [addHotelBlockRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelAddHotelBlockPostAxiosParamCreator (addHotelBlockRequest?: AddHotelBlockRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/AddHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(addHotelBlockRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelDeleteHotelBlockDelete - axios parameter creator
 * 
 * @summary Delete Hotel Block with its Details
 * @param {number} [blockId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelDeleteHotelBlockDeleteAxiosParamCreator (blockId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/DeleteHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (blockId !== undefined) {
        localVarQueryParameter['blockId'] = blockId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelHotelBlockDetailGet - axios parameter creator
 * 
 * @summary Get Hotel Block Detail
 * @param {string} [cityName] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelHotelBlockDetailGetAxiosParamCreator (cityName?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlockDetail`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (cityName !== undefined) {
        localVarQueryParameter['cityName'] = cityName;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelHotelBlockListGet - axios parameter creator
 * 
 * @summary Get Hotel Block List
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelHotelBlockListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlockList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelHotelBlocksGet - axios parameter creator
 * 
 * @summary Get Hotel Block Detail to preview
 * @param {number} [blockId] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelHotelBlocksGetAxiosParamCreator (blockId?: number, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/HotelBlocks`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (blockId !== undefined) {
        localVarQueryParameter['blockId'] = blockId;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelUpdateHotelBlockPost - axios parameter creator
 * 
 * @summary Update Hotel Block with details
 * @param {UpdateHotelBlockRequest} [updateHotelBlockRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelUpdateHotelBlockPostAxiosParamCreator (updateHotelBlockRequest?: UpdateHotelBlockRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/UpdateHotelBlock`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(updateHotelBlockRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * HotelBlocksApiApiHotelVisibleHotelBlockListGet - axios parameter creator
 * 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function HotelBlocksApiApiHotelVisibleHotelBlockListGetAxiosParamCreator (options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/hotel/VisibleHotelBlockList`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiHotelAddHotelBlockPost operation in HotelBlocksApi.
 * @export
 * @interface HotelBlocksApiApiHotelAddHotelBlockPostRequest
 */
export interface HotelBlocksApiApiHotelAddHotelBlockPostRequest {
    /**
     * 
     * @type {AddHotelBlockRequest}
     * @memberof HotelBlocksApiApiHotelAddHotelBlockPost
     */
    readonly addHotelBlockRequest?: AddHotelBlockRequest
}

/**
 * Request parameters for apiHotelDeleteHotelBlockDelete operation in HotelBlocksApi.
 * @export
 * @interface HotelBlocksApiApiHotelDeleteHotelBlockDeleteRequest
 */
export interface HotelBlocksApiApiHotelDeleteHotelBlockDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelBlocksApiApiHotelDeleteHotelBlockDelete
     */
    readonly blockId?: number
}

/**
 * Request parameters for apiHotelHotelBlockDetailGet operation in HotelBlocksApi.
 * @export
 * @interface HotelBlocksApiApiHotelHotelBlockDetailGetRequest
 */
export interface HotelBlocksApiApiHotelHotelBlockDetailGetRequest {
    /**
     * 
     * @type {string}
     * @memberof HotelBlocksApiApiHotelHotelBlockDetailGet
     */
    readonly cityName?: string
}

/**
 * Request parameters for apiHotelHotelBlocksGet operation in HotelBlocksApi.
 * @export
 * @interface HotelBlocksApiApiHotelHotelBlocksGetRequest
 */
export interface HotelBlocksApiApiHotelHotelBlocksGetRequest {
    /**
     * 
     * @type {number}
     * @memberof HotelBlocksApiApiHotelHotelBlocksGet
     */
    readonly blockId?: number
}

/**
 * Request parameters for apiHotelUpdateHotelBlockPost operation in HotelBlocksApi.
 * @export
 * @interface HotelBlocksApiApiHotelUpdateHotelBlockPostRequest
 */
export interface HotelBlocksApiApiHotelUpdateHotelBlockPostRequest {
    /**
     * 
     * @type {UpdateHotelBlockRequest}
     * @memberof HotelBlocksApiApiHotelUpdateHotelBlockPost
     */
    readonly updateHotelBlockRequest?: UpdateHotelBlockRequest
}

/**
* 
* @summary Add Hotel Block with details
* @param {HotelBlocksApiApiHotelAddHotelBlockPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelAddHotelBlockPost(requestParameters: HotelBlocksApiApiHotelAddHotelBlockPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelAddHotelBlockPostAxiosParamCreator(requestParameters.addHotelBlockRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Delete Hotel Block with its Details
* @param {HotelBlocksApiApiHotelDeleteHotelBlockDeleteRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelDeleteHotelBlockDelete(requestParameters: HotelBlocksApiApiHotelDeleteHotelBlockDeleteRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelDeleteHotelBlockDeleteAxiosParamCreator(requestParameters.blockId, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel Block Detail
* @param {HotelBlocksApiApiHotelHotelBlockDetailGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelHotelBlockDetailGet(requestParameters: HotelBlocksApiApiHotelHotelBlockDetailGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelHotelBlockDetailGetAxiosParamCreator(requestParameters.cityName, options, configuration);
    const request: () => AxiosPromise<Array<GetHotelBlockDetailsResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel Block List
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelHotelBlockListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelHotelBlockListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<Array<GetHotelBlockListResponse>> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Get Hotel Block Detail to preview
* @param {HotelBlocksApiApiHotelHotelBlocksGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelHotelBlocksGet(requestParameters: HotelBlocksApiApiHotelHotelBlocksGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelHotelBlocksGetAxiosParamCreator(requestParameters.blockId, options, configuration);
    const request: () => AxiosPromise<HotelBlockResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @summary Update Hotel Block with details
* @param {HotelBlocksApiApiHotelUpdateHotelBlockPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelUpdateHotelBlockPost(requestParameters: HotelBlocksApiApiHotelUpdateHotelBlockPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelUpdateHotelBlockPostAxiosParamCreator(requestParameters.updateHotelBlockRequest, options, configuration);
    const request: () => AxiosPromise<void> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function HotelBlocksApiApiHotelVisibleHotelBlockListGet(options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await HotelBlocksApiApiHotelVisibleHotelBlockListGetAxiosParamCreator(options, configuration);
    const request: () => AxiosPromise<GetVisibleHotelBlockResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
